import LazyLoad from "vanilla-lazyload";
import Masonry from "masonry-layout";
//import Cookies from "js-cookie";
const Flickity = require("flickity");
import "flickity-fade";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);
//import zenscroll from "zenscroll";
import * as CookieConsent from "vanilla-cookieconsent";

/* SETUP VARS */

// loose grid text entries are sized against this canvas width, the same as
// in the CMS editor — keep it in sync with NATIVE_LOOSE_WIDTH in
// src/manage_canvas.js
const NATIVE_LOOSE_WIDTH = 1920;
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
let overlayInner, overlayCloser;
if (typeof overlay != "undefined" && overlay != null) {
  overlayInner = overlay.querySelector(".inner");
  overlayCloser = overlay.querySelector(".closer");
}

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  /**
   * All config. options available here:
   * https://cookieconsent.orestbida.com/reference/configuration-reference.html
   */

  // Detect GPC signal and any prior explicit decision
  const gpcEnabled = navigator.globalPrivacyControl === true;
  const hasExistingDecision = document.cookie.includes("cc_cookie="); // default cookie name — adjust if you've customized it

  CookieConsent.run({
    categories: {
      necessary: {
        enabled: true, // this category is enabled by default
        readOnly: true, // this category cannot be disabled
      },
      analytics: {
        autoClear: {
          cookies: [
            { name: /^_ga/, domain: "salt-la.com" },
            { name: "_gid", domain: "salt-la.com" },
          ],
        },
      },
    },
    onFirstConsent: ({ cookie }) => updateGtagConsent(cookie),
    onConsent: ({ cookie }) => updateGtagConsent(cookie),
    onChange: ({ cookie }) => updateGtagConsent(cookie),
    language: {
      default: "en",
      translations: {
        en: {
          consentModal: {
            title: "Cookie Usage",
            description:
              "We use cookies to operate our website and, with your consent, to understand how visitors use it through Google Analytics. You can accept all cookies, reject non-essential cookies, or manage your preferences. You may change your selection at any time using the Cookie Preferences link in the footer.",
            acceptAllBtn: "Accept All",
            acceptNecessaryBtn: "Reject Non-Essential",
            showPreferencesBtn: "Manage Preferences",
          },
          preferencesModal: {
            title: "Manage cookie preferences",
            acceptAllBtn: "Accept All",
            acceptNecessaryBtn: "Reject Non-Essential",
            savePreferencesBtn: "Accept current selection",
            closeIconLabel: "Close modal",
            sections: [
              {
                title: "Types of cookies",
                description:
                  "We use necessary and analytics cookies on our website.",
              },
              {
                title: "Necessary cookies",
                description:
                  "Necessary cookies are required for the website to function and cannot be disabled through our cookie preferences tool. These include session cookies that help operate the website.",
                linkedCategory: "necessary",
              },
              {
                title: "Performance and Analytics",
                description:
                  "Analytics cookies help us understand how visitors use our website so we can improve it. These cookies are used only if you consent.",
                linkedCategory: "analytics",
              },
              {
                title: "More information",
                description:
                  'For any queries in relation to our policy on cookies and your choices, please review our <a href="/cookie-policy">cookie policy</a>.',
              },
            ],
          },
        },
      },
    },
  });

  function updateGtagConsent(cookie) {
    if (typeof gtag !== "function") return;
    gtag("consent", "update", {
      analytics_storage: cookie.categories.includes("analytics")
        ? "granted"
        : "denied",
    });
  }

  // If GPC is active and the user hasn't made a choice yet, auto-reject
  // non-essential categories and suppress the initial banner
  if (gpcEnabled && !hasExistingDecision) {
    CookieConsent.acceptCategory(["necessary"]);
  }

  // Set mobile View
  function setMobileVH() {
    if (window.innerWidth <= 768) {
      // Set vh to 100% of the viewport height
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`,
      );
    }
  }
  setMobileVH();
  window.addEventListener("resize", setMobileVH);

  ScrollSmoother.create({
    smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true, // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  });

  // check for any social icons
  // if (typeof socialIcons != "undefined") {
  //   socialIcons(socialEl);
  // }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  function loadInit() {
    // global animation effects
    ScrollTrigger.batch(".fadeUp", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });

    ScrollTrigger.batch(".fadeOn", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, stagger: 0.1 });
      },
    });

    setTimeout(function () {
      ScrollTrigger.batch(".fadeUpDelay", {
        onEnter: (elements, triggers) => {
          gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
        },
      });
    }, 300);

    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });
  }

  loadInit();

  // loose grids

  let looseGrids = document.querySelectorAll(".grid_loose");
  looseGrids.forEach((looseGrid) => {
    let catid = looseGrid.getAttribute("data-catid");
    let grid;
    let view = "desktop";
    let resizeTimeout;

    function scaleCanvas() {
      const grid = looseGrid.querySelector("ul.canvas");
      const parent = grid.parentElement;
      const baseWidth = innerWidth > 768 ? 1600 : 440;
      const scale = parent.offsetWidth / baseWidth;
      grid.style.transform = `scale(${scale})`;
      setTimeout(() => {
        grid.style.opacity = 1;
      }, 225);
    }

    function checkView() {
      let newView = innerWidth <= 768 ? "mobile" : "desktop";
      if (view !== newView) {
        view = newView;
        return true;
      }
      return false;
    }

    function loadGrid() {
      fetch(`/getCanvas.php?catid=${catid}&view=${view}`)
        .then((response) => response.text())
        .then((data) => {
          looseGrid.innerHTML = data;
          grid = looseGrid.querySelector("ul.canvas");

          // the canvas is laid out at a fixed width (1600 desktop / 440
          // mobile) and scaled to fit by scaleCanvas(), so text only needs
          // normalising against that layout width for it to wrap and size
          // the same, relative to the canvas, as in the CMS. Set before the
          // grid fades in so text never flashes at full px size.
          const layoutWidth = innerWidth > 768 ? 1600 : 440;
          looseGrid.style.setProperty(
            "--text-scale",
            layoutWidth / NATIVE_LOOSE_WIDTH,
          );

          /*
          const resizeObserver = new ResizeObserver(updatePositions);
          resizeObserver.observe(grid);
          */

          loadInit();
          updatePositions();

          setTimeout(function () {
            updateContainerHeight();
            scaleCanvas();
          }, 500);
        })
        .catch((error) => console.error("Error:", error));
    }

    // Initial check and load
    checkView();
    loadGrid();

    // Debounced window resize handler
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        scaleCanvas();
        updateContainerHeight();
        if (checkView()) {
          loadGrid();
        }
      }, 250); // Wait 250ms after last resize event
    });

    function updatePositions() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      //const { width, height } = grid.getBoundingClientRect();

      const width = innerWidth > 768 ? 1600 : 440;

      items.forEach((item) => {
        let percentX = parseFloat(item.dataset.x);
        let percentY = parseFloat(item.dataset.y);
        let percentWidth = parseFloat(item.dataset.width);

        // apply the new positions as pixels
        item.style.left = `${(percentX / 100) * width}px`;
        item.style.top = `${(percentY / 100) * width}px`; // Base top on width
        item.style.width = `${(percentWidth / 100) * width}px`;

        // clear out transforms from draggable
        gsap.set(item, {
          x: 0,
          y: 0,
          z: 0,
        });
      });

      updateContainerHeight();
    }

    function updateContainerHeight() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      // Calculate scale factor
      const baseWidth = innerWidth > 768 ? 1600 : 440;
      const scale = grid.parentElement.offsetWidth / baseWidth;

      let maxBottom = 0;
      items.forEach((item) => {
        let topPos = parseFloat(item.style.top) || 0;
        let itemBottom = topPos + item.offsetHeight;
        maxBottom = Math.max(maxBottom, itemBottom);
      });

      // Set the container height to the scaled grid height
      grid.style.height = `${Math.ceil(maxBottom)}px`;
      looseGrid.style.height = `${Math.ceil(maxBottom * scale)}px`;
      grid.style.minHeight = "auto";
    }
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  //initialize flickity for slideshows

  let slideshowEls = document.querySelectorAll(".flickity-slideshow");
  let counterEl = document.querySelector(".counter .current");

  if (slideshowEls.length > 0) {
    slideshowEls.forEach((slideshowEl) => {
      let autoplay = slideshowEl.getAttribute("data-autoplay");
      if (autoplay === "no") {
        autoplay = false;
      } else {
        autoplay = 3000; // default to 3 seconds if not specified
      }

      let flkty = new Flickity(slideshowEl, {
        // options
        contain: false,
        cellSelector: ".flickity-cell",
        pageDots: false,
        prevNextButtons: false,
        autoPlay: autoplay,
        pauseAutoPlayOnHover: true,
        wrapAround: true,
        // setGallerySize: false,
        percentPosition: false,
      });

      // change event
      // flkty.on("change", function (index) {
      //   let slideCount = index + 1;
      //   counterEl.innerHTML = slideCount;
      // });
      if (typeof flkty !== "undefined") {
        flkty.resize();
      }
    });
  }
  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";

    // remove any hash values from the URL
    history.pushState(
      "",
      document.title,
      window.location.pathname + window.location.search,
    );
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // ---------------- SEARCH FUNCTIONALITY --------------------
  // Check if in mobile portrait mode
  let table;
  if (
    window.matchMedia("(max-width: 767px) and (orientation: portrait)").matches
  ) {
    table = document.getElementById("project-table-mobile");
  } else {
    table = document.getElementById("project-table");
  }
  if (typeof table != "undefined" && table != null) {
    const tbody = table.querySelector("tbody");
    const search = document.getElementById("table-search");
    const headers = table.querySelectorAll("th.sortable");
    let sortDirs = Array(headers.length).fill("asc");

    // Live filter
    search.addEventListener("input", () => {
      const q = search.value.trim().toLowerCase();
      Array.from(tbody.rows).forEach((row) => {
        row.style.display = row.textContent.toLowerCase().includes(q)
          ? ""
          : "none";
      });
    });

    // Column-sort
    headers.forEach((th, idx) => {
      th.addEventListener("click", () => {
        // toggle direction
        sortDirs[idx] = sortDirs[idx] === "asc" ? "desc" : "asc";
        headers.forEach((h) => h.classList.remove("asc", "desc"));
        th.classList.add(sortDirs[idx]);

        // collect only visible rows
        const rows = Array.from(tbody.rows).filter(
          (r) => r.style.display !== "none",
        );

        // sort by column idx
        rows.sort((a, b) => {
          const aText = a.cells[idx].textContent.trim();
          const bText = b.cells[idx].textContent.trim();
          return sortDirs[idx] === "asc"
            ? aText.localeCompare(bText, undefined, { numeric: true })
            : bText.localeCompare(aText, undefined, { numeric: true });
        });

        // re-append in order
        rows.forEach((r) => tbody.appendChild(r));
      });
    });
  }

  // ---------------- END SEARCH FUNCTIONALITY --------------------

  // news grid filter
  let newsFilter = document.getElementById("news-filter");
  if (newsFilter) {
    let newsCells = document.querySelectorAll(".news-grid .cell");
    let toggle = newsFilter.querySelector(".dropdown-toggle");
    let current = document.getElementById("news-filter-current");
    let options = newsFilter.querySelectorAll("[role='option']");

    options.forEach((option) => option.setAttribute("tabindex", "-1"));

    const setOpen = (open) => {
      newsFilter.classList.toggle("open", open);
      toggle.setAttribute("aria-expanded", open);
      if (open) {
        (newsFilter.querySelector("[aria-selected='true']") || options[0]).focus();
      }
    };

    const selectOption = (option) => {
      const tag = option.dataset.value;
      options.forEach((o) => o.setAttribute("aria-selected", o === option));
      current.textContent = option.textContent;
      newsCells.forEach((cell) => {
        const cellTags = cell.dataset.tags ? cell.dataset.tags.split(",") : [];
        cell.classList.toggle("hidden", tag !== "" && !cellTags.includes(tag));
      });
      setOpen(false);
      toggle.focus();
      ScrollTrigger.refresh();
    };

    toggle.addEventListener("click", function () {
      setOpen(!newsFilter.classList.contains("open"));
    });

    options.forEach((option, i) => {
      option.addEventListener("click", () => selectOption(option));
      option.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          selectOption(option);
        } else if (e.key === "ArrowDown") {
          e.preventDefault();
          options[Math.min(i + 1, options.length - 1)].focus();
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          options[Math.max(i - 1, 0)].focus();
        }
      });
    });

    newsFilter.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && newsFilter.classList.contains("open")) {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener("click", (e) => {
      if (!newsFilter.contains(e.target)) setOpen(false);
    });
  }

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      let href = overlayLink.getAttribute("href");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        openOverlay();

        // add the id to the URL as a hash value.  I want the back button to close the overlay
        history.pushState(
          { overlayOpen: true },
          document.title,
          window.location.href + href,
        );
      });
    });
  });

  let jobLinks = document.querySelectorAll(".openJob");
  jobLinks.forEach((jobLink) => {
    jobLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = jobLink.getAttribute("data-id");

      getAjax("/getJob.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        const lazyLoadAutoVideo = new LazyLoad({
          elements_selector: ".autovideo",
          threshold: 30,
          callback_enter: playAutoVideo,
          callback_exit: pauseAutoVideo,
        });
        openOverlay();
      });
    });
  });

  // Hero hover on homepage
  let twoColHero = document.querySelector(".two-column-hero");
  if (typeof twoColHero != "undefined" && twoColHero != null) {
    let hoverTriggers = twoColHero.querySelectorAll("h1");
    hoverTriggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", function (e) {
        if (!trigger.classList.contains("hovered")) {
          trigger.classList.add("hovered");
        }
      });
      document.addEventListener("mousemove", function (e) {
        const inner = trigger.closest(".inner");
        if (inner && !inner.contains(e.target)) {
          if (trigger.classList.contains("hovered")) {
            trigger.classList.remove("hovered");
          }
        }
      });
    });
  }

  // Scroll button on hero
  let scrollBtn = document.querySelector(".scroll-btn");
  if (typeof scrollBtn != "undefined" && scrollBtn != null) {
    let scrollTL = gsap.timeline({ repeat: -1, repeatDelay: 2 });
    scrollTL
      .to(scrollBtn, { y: 12, ease: "power1.none", duration: 0.4 })
      .to(scrollBtn, { y: 0, ease: "power1.out", duration: 0.2 })
      .to(scrollBtn, { y: 8, ease: "power1.none", duration: 0.2 })
      .to(scrollBtn, { y: 0, ease: "power1.out", duration: 0.4 });

    scrollBtn.addEventListener("click", function (e) {
      // Scroll to next section, but only if NOT phone-landscape
      if (
        !window.matchMedia("(max-width: 932px) and (orientation: landscape)")
          .matches
      ) {
        gsap.to(window, {
          scrollTo: {
            y: innerHeight,
            autoKill: false,
          },
          duration: 0.7,
          ease: "power1.inOut",
        });
      } else {
        gsap.to(window, {
          scrollTo: {
            y: innerHeight / 2,
            autoKill: false,
          },
          duration: 0.7,
          ease: "power1.inOut",
        });
      }
    });
  }

  //hamburger menu toggle
  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        (event.preventDefault(), document.body.classList.toggle("menuOn"));
      },
      true,
    );
  }

  // close overlay
  if (typeof overlay != "undefined" && overlay != null) {
    overlayCloser.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        closeOverlay();
      },
      true,
    );
  }

  // start push state functions

  // Handle browser back/forward buttons
  window.addEventListener("popstate", async (event) => {
    // If overlay is open and hash is removed, close overlay
    if (overlay.classList.contains("on") && !location.hash) {
      closeOverlay();
      return;
    }

    const url = window.location.pathname;
    await loadContent(url);
  });

  const pageCache = new Map();
  const CACHE_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes in milliseconds

  function pushStateInit() {
    // top level pages
    let pushStateLinks = document.querySelectorAll(".pushstate");
    if (typeof pushStateLinks != "undefined" && pushStateLinks != null) {
      pushStateLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          let url = link.getAttribute("href");
          loadContent(url);
          closeOverlay();
        });
      });
    }
  }

  pushStateInit();

  async function loadContent(url) {
    // Prevent loading if already in progress
    if (loadContent.isLoading) return;
    loadContent.isLoading = true;

    try {
      // apply any resets
      closeNav();

      const parentEl = document.querySelector("section#content");

      // Start loading content immediately
      const [content] = await Promise.all([
        (async () => {
          const cached = pageCache.get(url);
          const now = Date.now();
          if (cached && now - cached.timestamp < CACHE_EXPIRY_MS) {
            return Promise.resolve(cached.content);
          }
          const response = await fetch(`/content.php?page=${url}`);
          if (!response.ok)
            throw new Error(`HTTP error! status: ${response.status}`);
          const text = await response.text();
          pageCache.set(url, { content: text, timestamp: now });
          return text;
        })(),
        gsap
          .to(parentEl, {
            opacity: 0,
            duration: 0.3,
            ease: "power1.out",
          })
          .then(),
      ]);

      body.classList.remove(
        "projectpage",
        "textpage",
        "homepage",
        "intro_playing",
      );

      // Update content and fade in
      parentEl.innerHTML = content;

      // general functions
      loadInit();
      animationInit();
      pushStateInit();
      playFullVideoInit();
      gridTitleAnimation();

      // colect page specific vars
      let newContentEl = parentEl.querySelector("article.inner");
      let newBodyClass = newContentEl.getAttribute("data-bodyclass");
      let bgColor = newContentEl.getAttribute("data-bgcolor");
      let primaryColor = newContentEl.getAttribute("data-primarycolor");

      // apply updated body vars
      document.body.style.backgroundColor = bgColor;
      document.body.style.color = primaryColor;

      if (newBodyClass != "") {
        body.classList.add(...newBodyClass.split(" ")); // Add new classes while keeping existing ones
      }

      // page specific functions
      let arRowsEl = newContentEl.querySelector(".ar-rows");
      if (typeof arRowsEl != "undefined" && arRowsEl != null) {
        let arRowsEls = newContentEl.querySelectorAll(".ar-rows");
        arRows(arRowsEls);
        arRowsReveal();
      }

      let masonGrids = newContentEl.querySelector(".masongrid");
      if (typeof masonGrids != "undefined" && masonGrids != null) {
        W;
        masonryInit();
      }

      let marqueeCheck = newContentEl.querySelector(".marquee .carousel");
      if (typeof marqueeCheck != "undefined" && marqueeCheck != null) {
        marqueeInits();
      }

      let textPageCheck = parentEl.querySelector(".textpage");
      if (typeof textPageCheck != "undefined" && textPageCheck != null) {
        textPageAnimation();
      }

      let projectPageCheck = parentEl.querySelector(".modules");
      if (typeof projectPageCheck != "undefined" && projectPageCheck != null) {
        projectSidebarsInit();
        projectDetailAnimation();
      }

      let homepageCheck = parentEl.querySelector(".home");
      if (typeof homepageCheck != "undefined" && homepageCheck != null) {
        gsap.set(headerLogo, { opacity: 0 });
        homepageInit();
      } else {
        // make sure logo is visible, may need to do a check for homepage here
        gsap.set(headerLogo, { opacity: 1 });
      }

      gsap.to(parentEl, {
        opacity: 1,
        duration: 0.5,
      });

      // Update history
      history.pushState(null, null, url);

      // scroll to top of page
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 100);

      return content;
    } catch (error) {
      console.error("Failed to load content:", error);
      // Fade back in if there's an error
      const parentEl = document.querySelector("section#content");
      gsap.to(parentEl, { opacity: 1, duration: 0.5 });
    } finally {
      loadContent.isLoading = false;
    }
  }
});
